import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import ConfirmModal from "../Confirm";
import { openModal } from "../../../../store/Modals/actions";
import {
  MODAL_CONFIRM,
  MODAL_UNLOCK_FOLDER,
} from "../../../../store/Modals/constants";
import { CONFIRM_UNLOCK } from "../Confirm/constants";
import { unlockFolder } from "../../../../store/File/actions";

const Unlock = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(openModal(MODAL_CONFIRM));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ConfirmModal
      modal={MODAL_UNLOCK_FOLDER}
      action={() => dispatch(unlockFolder())}
      message={CONFIRM_UNLOCK}
    />
  );
};

export default Unlock;
